import { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@ui/lib/utils';

const tabLinkVariants = cva('typography-title-4 text-nowrap', {
  variants: {
    variant: {
      primary: [
        'flex h-xxl items-center justify-center rounded-full px-md text-on-secondary-surface',
        'border border-line hover:border-tertiary',
        'data-[state=active]:bg-tertiary data-[state=active]:border-none',
        'focus-visible:border focus-visible:border-tertiary', // Focus state
      ],
      secondary: [
        'flex flex-col items-start justify-between gap-xs-sm',
        'text-on-primary-surface-subdued hover:text-on-primary-surface',
        'data-[state=active]:text-on-primary-surface',
      ],
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export type TabLinkProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof tabLinkVariants>;

export const TabLink = forwardRef<HTMLButtonElement, TabLinkProps>(
  ({ className, variant, children, ...rest }, ref) => (
    <button
      ref={ref}
      className={cn(tabLinkVariants({ variant }), 'group', className)}
      {...rest}
    >
      {children}

      {variant === 'secondary' && (
        <div
          className={cn(
            'h-0.5 self-stretch rounded-t',
            'bg-transparent group-hover:bg-brand-base',
            'group-data-[state=active]:bg-brand-strongest',
          )}
        />
      )}
    </button>
  ),
);

TabLink.displayName = 'TabLink';
